module.exports = "/_next/static/images/lock-line-b4f47a869c0981f87bec77873911792a.svg";